import styled from 'styled-components';
import { Button } from 'antd';
import { StyledBaseChart } from '../../styles/timelineEventsStyled';

export const StyledOverview = styled.div`
  display: flex;
  padding: 0 0px;
  position: relative;
  ${StyledBaseChart} {
    z-index: 2;
    image {
      preserveaspectratio: none;
    }
  }
`;

export const StyledLeftButton = styled(Button)`
  position: absolute;
  top: 72px;
  left: 20px;
  border: none;
  z-index: 10;
  color: #dadada !important;
  background: transparent !important;
`;

export const StyledRightButton = styled(Button)`
  position: absolute;
  top: 72px;
  right: 20px;
  border: none;
  color: #dadada;
  z-index: 10;
  background: transparent;
`;
